//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Button',

  props: {
    label: String,
    type: String,
    icon: String,
    red: Boolean,
    disabled: Boolean,
    hint: String
  },

  components: {},

  computed: {
    color() {
      if (this.type === 'outline') {
        return this.red ? 'negative' : 'blue-grey-7'
      }
      return 'primary'
    }
  },

  methods: {}
}
